import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Form } from 'react-bootstrap';
import { IoAddOutline, IoDocumentTextOutline, IoSearch, IoSettingsOutline } from 'react-icons/io5';
import OutletHead from '../../../components/common/outlet-head';
import DataTable from '../../../components/associates/datatables';
import { query, collection, onSnapshot, orderBy } from "firebase/firestore";
import { db } from '../../../firebase';

function Associates() {

  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState(null);
  const [searchData, setSearchData] = useState({
    searchBy: 'aadharNumber',
    searchTerm: ''
  });

  function getAssociates() {
    const q = query(collection(db, "Associates"), orderBy('name'));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const tempData = [];
      querySnapshot.forEach((doc) => {
        tempData.push({ id: doc.id, ...doc.data() });
      });
      setData(tempData);
      setIsLoading(false);
    }, (error) => {
      console.log(error.message);
    });

    return () => unsubscribe;
  }

  useEffect(() => {
    getAssociates();
  }, []);

  // const handleSearch = (event) => {
  //   event.preventDefault();
  //   let { searchBy, searchTerm } = searchData;
  //   if (searchBy && searchTerm) {
  //     const partyRef = collection(db, "Parties");
  //     const q = query(partyRef, where(searchBy, "in", [searchTerm]));
  //     const unsubscribe = onSnapshot(q, (querySnapshot) => {
  //       const tempData = [];
  //       querySnapshot.forEach((doc) => {
  //         tempData.push({ id: doc.id, ...doc.data() });
  //       });

  //       setData(tempData);
  //     }, (error) => {
  //       console.log(error.message);
  //     });

  //     return () => unsubscribe;
  //   } else {
  //     getParties();
  //   }
  // }

  return (

    <section className='section'>
      <OutletHead
        left={
          <h5 className='mb-0 fw-600'>Associates</h5>
        }
        right={
          <div className='d-flex align-items-center'>
            <Button
              variant="outline-primary"
              type="submit"
              className='py-2 px-4 me-3'
            >
              <IoDocumentTextOutline size={18} />
              <span className='ps-2'>Export</span>
            </Button>
            <Button
              variant="light"
              type="submit"
              className='border py-2 px-4'
            >
              <IoSettingsOutline size={20} />
              <span className='ps-2'>Settings</span>
            </Button>
          </div>
        }
      />
      <div className='p-3 border-top'>
        <div className='row'>
          <div className='col-lg-12'>
            {
              isLoading ?
                <div className='data-loading-container'>
                  <div className='loader'>
                    <div className='spinner' />
                  </div>
                </div>
                :
                <div className='mb-5'>
                  <div className='pb-3'>
                    <Form onSubmit={null}>
                      <div className='row'>
                        <div className='col-8'>
                          <div className='row'>
                            <div className='col-lg-6 col-md-6 col-12'>
                              <div className='position-relative'>
                                <div className='position-absolute left-0 top-0 bottom-0 ps-3 d-flex align-items-center justify-content-center'>
                                  <IoSearch size={20} color={`var(--bs-placeholder)`} />
                                </div>
                                <Form.Control
                                  type="text"
                                  placeholder="Search your associate"
                                  onChange={(e) => {
                                    if (e.target.value) {
                                      setSearchData({
                                        ...searchData,
                                        searchTerm: e.target.value
                                      });
                                    } else {
                                      getAssociates();
                                    }
                                  }}
                                  className='ps-5'
                                />
                              </div>
                            </div>
                            <div className='col-lg-4 col-md-4 col-12'>
                              <Form.Select
                                onChange={(e) => {
                                  if (e.target.value) {
                                    setSearchData({
                                      ...searchData,
                                      searchBy: e.target.value
                                    })
                                  } else {
                                    getAssociates();
                                  }
                                }}
                              >
                                <option value="aadhar_no">Location</option>
                              </Form.Select>
                            </div>
                          </div>
                        </div>
                        <div className='col-4'>
                          <div className='d-flex align-items-center justify-content-end'>
                            <Link to="add">
                              <Button
                                variant="primary"
                                type="button"
                                className='py-2 px-3'
                              >
                                <IoAddOutline size={21} />
                                <span className='ps-2'>Add Associate</span>
                              </Button>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </Form>
                  </div>
                  <DataTable
                    columns={['#', '', 'Associate Name', "Father/Husband", 'Phone Number', 'City & State', 'Status']}
                    data={data}
                  />
                </div>
            }
          </div>
        </div>
      </div>
    </section>
  );
}

export default Associates;
